import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Select, { StylesConfig } from 'react-select';
import { toast } from 'react-toastify';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import TextField from '../../../../core/common/textFields/TextField';
import { useCreateUpdateSpecificationExceptionMutation, useGetSpecificationExceptionQuery } from '../../../../services/EndPointsApis';

const SpecificationExceptionSaleWizard = ({ projectLookups,formik, projectId, showRibbon,storeProjectId,setShowSpecificationExceptionData,showSpecificationExceptionUpdate }: any) => {

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    // const ProjectId = useSelector((state: any) => state.common.projectId);
    const params = useParams()
    //Create Update Exception 
    // const [UpsertException, { data, isError, error, isSuccess, isLoading }] = useCreateUpdateSpecificationExceptionMutation();
    //Get Exeption
    // const { data: exceptionData, refetch, isLoading: isLoadingEcxeption } = useGetSpecificationExceptionQuery({ projectId: projectId||storeProjectId });


    useEffect(() => {
        if (setShowSpecificationExceptionData) {
            setShowSpecificationExceptionData(formik)
        }
    }, [setShowSpecificationExceptionData, formik.values])

    useEffect(() => {
        if (showSpecificationExceptionUpdate && Object.keys(showSpecificationExceptionUpdate).length > 0) {
            formik.setValues({ ...showSpecificationExceptionUpdate });
        }
    }, [showSpecificationExceptionUpdate]);


    // useEffect(() => {
    //     if (exceptionData?.result && Object.keys(exceptionData?.result).length > 0) {
    //         formik.setValues({ ...exceptionData?.result, projectId: projectId });
    //         // setDisabledata(true)
    //     } else {
    //         // setUpdateId(0);
    //     }
    // }, [exceptionData]);

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className='card'>
                    <div className='card-body p-3'>
                        <div className='row m-0'>
                            <div className='col-md-6'>
                                <label className='input-label'>Exception Type </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={projectLookups?.result?.Lst_ExceptionType?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values?.lst_ExceptionType?.id
                                            ? {
                                                value: formik.values?.lst_ExceptionType?.id,
                                                label: formik.values?.lst_ExceptionType?.value || '',
                                            }
                                            : null
                                    }
                                    // isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_ExceptionType.id', selectedOption.value);
                                        formik.setFieldValue('lst_ExceptionType.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            <div className='col-md-6'>
                                <label className='input-label'>Exception Category </label>
                                <Select
                                    styles={customStyles}
                                    className="select"
                                    options={projectLookups?.result?.Lst_ExceptionCategory?.map((option: any) => ({
                                        label: option?.value,
                                        value: option?.id
                                    }))}
                                    value={
                                        formik.values?.lst_ExceptionCategory?.id
                                            ? {
                                                value: formik.values?.lst_ExceptionCategory?.id,
                                                label: formik.values?.lst_ExceptionCategory?.value || '',
                                            }
                                            : null
                                    }
                                    // isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_ExceptionCategory.id', selectedOption.value);
                                        formik.setFieldValue('lst_ExceptionCategory.value', selectedOption.label);
                                    }}
                                />
                            </div>
                            <div className='col-md-4'>
                                <label className="input-label">
                                    Amount Impacted?
                                </label>
                                <label className="checkboxs mt-1 mb-4">
                                    <input
                                        type="checkbox"
                                        checked={formik.values.amountImpacted}
                                        // disabled={viewOnly}
                                        {...formik.getFieldProps("amountImpacted")}
                                    />
                                    <span className="checkmarks" />
                                </label>
                            </div>
                            <div className='col-md-4'>
                                <label className="input-label">
                                    Scope Impacted?
                                </label>
                                <label className="checkboxs mt-1 mb-4">
                                    <input
                                        type="checkbox"
                                        checked={formik.values.scopeImpacted}
                                        // disabled={viewOnly}
                                        {...formik.getFieldProps("scopeImpacted")}
                                    />
                                    <span className="checkmarks" />
                                </label>
                            </div>
                            <div className='col-md-4'>
                                <label className="input-label">
                                    TimeLine Impacted?
                                </label>
                                <label className="checkboxs mt-1 mb-4">
                                    <input
                                        type="checkbox"
                                        checked={formik.values.timelineImpacted}
                                        // disabled={viewOnly}
                                        {...formik.getFieldProps("timelineImpacted")}
                                    />
                                    <span className="checkmarks" />
                                </label>
                            </div>
                            <div className='col-md-12'>
                                <div className="form-wrap">
                                    <TextField
                                        label="Note"
                                        type="text"
                                        {...formik.getFieldProps("notes")}
                                        // disabled={viewOnly}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>

    )
}

export default SpecificationExceptionSaleWizard